import React, {FC, useState} from 'react'
import PrototypeCardComponent from './prototypeComponen';
import "../prototypeComponent.scss";

export interface PorotoTypeLeftPanelComponentProps {
    prototypeList: any;
  }

const PorotoTypeLeftPanelComponent: FC<PorotoTypeLeftPanelComponentProps> = ({prototypeList}) => {

    
    const renderPrototypes = () => {
        return prototypeList.map((prototype: any, i: number) => {
          return <PrototypeCardComponent key={`${prototype.id}-${i}`} prototype={prototype}/>;
        });
      };

    return (
        <div>
            {prototypeList != undefined && renderPrototypes()}
        </div>
    )
}

export default PorotoTypeLeftPanelComponent
